import { faqItems } from '@/mocks/homeData';

export default function SectionFaq() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于2828电影网，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto divide-y divide-background-200/70">
          {faqItems.map((item) => (
            <div key={item.id} className="py-4 md:py-5 first:pt-0 last:pb-0">
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-2">
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}